export default "__VITE_ASSET__BSz$HrWr__"